import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { GuaranteeLine } from './ui/GuaranteeLine';
import { FULL_MOCKUP_URL } from '../data/images';
import { BASE_CHECKOUT_URL, KIT_CHECKOUT_URL } from '../data/checkoutLinks';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const bigWords = ['MENOS IMPROVISACIÓN.', 'MÁS CRITERIO.', 'MÁS ESTRUCTURA.', 'MÁS MONITOR.'];
export function FinalCTA() {
  return <section className="relative overflow-hidden bg-mp-black py-24 md:py-32" data-id="element-109" data-mp="h414bm7iykg7">
      <div className="pointer-events-none absolute inset-0 court-lines opacity-40" aria-hidden="true" data-id="element-110" data-mp="vtylhi71e9vw" />
      <div className="pointer-events-none absolute inset-0" style={{
      background: 'radial-gradient(ellipse at 50% 20%, rgba(8,93,168,0.3), transparent 65%)'
    }} aria-hidden="true" data-id="element-111" data-mp="qwgkcdz9gyyg" />
      <Container className="relative z-10 text-center" data-id="element-112" data-mp="zua830iymka0">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.5,
        ease: easeOut
      }} data-id="element-113" data-mp="2c5pwtv1z1c26">
          <SectionTag tone="white" data-id="element-114" data-mp="2m1j87b3yezid">La próxima clase llegará igualmente.</SectionTag>
          <h2 className="mx-auto mt-5 max-w-[820px] font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-6xl" data-id="element-115" data-mp="2r2p4fiwtp4wn">
            La pregunta es si volverás a improvisarla.
          </h2>

          <div className="mx-auto mt-6 max-w-[600px] space-y-1 text-base leading-relaxed text-mp-gray md:text-lg" data-id="element-116" data-mp="3010wzqh92crq">
            <p data-id="element-117" data-mp="34vexu8eolc3s">No necesitas memorizar cientos de ejercicios.</p>
            <p data-id="element-118" data-mp="39r3r5u03xwrn">Necesitas saber: qué trabajar, por qué trabajarlo, cómo corregirlo y qué viene después.</p>
          </div>

          <div className="mx-auto my-10 h-px w-24 bg-mp-border" data-id="element-119" data-mp="3etclousmp6vv" />

          <p className="font-heading text-xl uppercase tracking-wide text-mp-lime sm:text-2xl" data-id="element-120" data-mp="3iu4y1wwsrrwd">
            Eso es Maestro en Pista.
          </p>

          <div className="mx-auto mt-8 max-w-[600px] space-y-1" data-id="element-121" data-mp="1jlz5abqkvzs5">
            {bigWords.map(word => <p key={word} className="font-heading text-2xl uppercase leading-tight text-mp-white sm:text-3xl md:text-4xl" data-id="element-122" data-mp="1enfkienq0u1d">
                {word}
              </p>)}
          </div>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: easeOut
      }} src={FULL_MOCKUP_URL} alt="Sistema completo Maestro en Pista" width={700} height={700} loading="lazy" className="mx-auto mt-14 w-full max-w-[500px]" data-id="element-123" data-mp="22ekyeoa3pc91" />

        <div className="mx-auto mt-14 grid max-w-[760px] grid-cols-1 gap-5 text-left sm:grid-cols-2" data-id="element-124" data-mp="h29p13ovhe43">
          <div className="rounded-2xl border border-mp-border bg-mp-dark/80 p-6" data-id="element-125" data-mp="d17xl91766co">
            <p className="font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-126" data-mp="2x113ke9by5l">Maestro en Pista</p>
            <p className="mt-3 font-heading text-4xl text-mp-white" data-id="element-127" data-mp="6wiagowt1fg1">17,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-128" data-mp="3pc2gss4r4hqu">Pago único</p>
            <CTAButton href={BASE_CHECKOUT_URL} variant="secondary" className="mt-5 w-full" showArrow data-id="element-129" data-mp="3u9ubftws6hyq">
              Quiero la versión base
            </CTAButton>
          </div>

          <div className="relative rounded-2xl border-2 border-mp-lime bg-mp-dark/80 p-6 shadow-glow-lime" data-id="element-130" data-mp="3kc7u70s0eebl">
            <span className="absolute -top-3 left-6 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-131" data-mp="36d83zooulrdb">
              Recomendado
            </span>
            <p className="mt-2 font-heading text-sm uppercase tracking-wide text-mp-white" data-id="element-132" data-mp="14l22usljscdd">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-3 font-heading text-4xl text-mp-lime" data-id="element-133" data-mp="19ibxcmnsne82">23,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-134" data-mp="35n1cp92pqf6z">
              Solo 6 € más que la versión base
            </p>
            <CTAButton href={KIT_CHECKOUT_URL} className="mt-5 w-full" showArrow data-id="element-135" data-mp="2vou6nl9yphjr">
              Quiero el sistema completo
            </CTAButton>
          </div>
        </div>

        <GuaranteeLine className="mt-6" data-id="element-136" data-mp="2rq4ntd65n7sq" />
      </Container>
    </section>;
}